import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AutoFocusedInputField, commanderForm, presence, ReadOnlyField, validation } from '@mews-commander/legacy-form';
import { FieldsContainer } from '@mews-commander/ui';
import ParentResourceSelectField from './ParentResourceSelectField';

const constraints = {
    name: { presence },
};

const ResourceForm = ({ scope }: { scope: string }) => (
    <FieldsContainer>
        <ReadOnlyField {...categoryProps} />
        <ReadOnlyField {...floorProps} />
        <AutoFocusedInputField name="name" label={<LocalizedText textKey={TextKey.Number} />} required />
        <ParentResourceSelectField scope={scope} />
    </FieldsContainer>
);

const categoryProps = {
    name: 'category',
    label: <LocalizedText textKey={TextKey.ResourceCategory} />,
};

const floorProps = {
    name: 'floor',
    label: <LocalizedText textKey={TextKey.Floor} />,
};

export default commanderForm({
    enableReinitialize: true,
    submitLabel: <LocalizedText textKey={TextKey.Save} />,
    validate: validation(constraints),
})(ResourceForm);
